export default "__VITE_ASSET__cdec8c66__"